import { z } from 'zod';
import { CategorySchema, CollectionSchema, ChatSchema } from './common.js';

/**
 * Series endpoint Zod schemas for Polymarket Gamma API
 */

export const ListSeriesParamsSchema = z.object({
  limit: z.number().optional(),
  offset: z.number().optional(),
  order: z.string().optional(),
  ascending: z.boolean().optional(),
  slug: z.array(z.string()).optional(),
  categories_ids: z.array(z.number()).optional(),
  categories_labels: z.array(z.string()).optional(),
  closed: z.boolean().optional(),
  include_chat: z.boolean().optional(),
  recurrence: z.string().optional(),
});

export const GetSeriesByIdParamsSchema = z.object({
  id: z.number(),
  include_chat: z.boolean().optional(),
});

// Forward declarations for circular dependencies
const EventSchema = z.unknown();
const TagSchema = z.unknown();

export const SeriesSchema = z.object({
  id: z.string(),
  ticker: z.string().nullable().optional(),
  slug: z.string().nullable().optional(),
  title: z.string().nullable().optional(),
  subtitle: z.string().nullable().optional(),
  seriesType: z.string().nullable().optional(),
  recurrence: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
  icon: z.string().nullable().optional(),
  layout: z.string().nullable().optional(),
  active: z.boolean().nullable().optional(),
  closed: z.boolean().nullable().optional(),
  archived: z.boolean().nullable().optional(),
  new: z.boolean().nullable().optional(),
  featured: z.boolean().nullable().optional(),
  restricted: z.boolean().nullable().optional(),
  isTemplate: z.boolean().nullable().optional(),
  templateVariables: z.boolean().nullable().optional(),
  publishedAt: z.string().nullable().optional(),
  createdBy: z.string().nullable().optional(),
  updatedBy: z.string().nullable().optional(),
  createdAt: z.string().nullable().optional(),
  updatedAt: z.string().nullable().optional(),
  commentsEnabled: z.boolean().nullable().optional(),
  competitive: z.string().nullable().optional(),
  volume24hr: z.number().nullable().optional(),
  volume: z.number().nullable().optional(),
  liquidity: z.number().nullable().optional(),
  startDate: z.string().nullable().optional(),
  pythTokenID: z.string().nullable().optional(),
  cgAssetName: z.string().nullable().optional(),
  score: z.number().nullable().optional(),
  events: z.array(EventSchema).optional(),
  collections: z.array(CollectionSchema).optional(),
  categories: z.array(CategorySchema).optional(),
  tags: z.array(TagSchema).optional(),
  commentCount: z.number().nullable().optional(),
  chats: z.array(ChatSchema).optional(),
});

export const ListSeriesRequestSchema = ListSeriesParamsSchema;

export const ListSeriesResponseSchema = z.object({
  data: z.array(SeriesSchema),
  total: z.number(),
  limit: z.number(),
  offset: z.number(),
});
